var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"singleSignOn"},[_c('div',{staticClass:"head"}),_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.newText))])]),_c('div',{staticClass:"footer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }